import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async'
import HorizontalDivider from 'src/components/shared/HorizontalDivider';
import OptionsButton from './components/OptionsButton';
import { useLocalization } from 'src/context/LocalizationContext';

export default function CargoPartnerReceivePage() {

    const { language } = useLocalization();
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();
    const { partner } = useParams();
    let partnerName = ""

    if (partner === "aras-kargo") {
        partnerName = "Aras Kargo"
    }
    if (partner === "dhl") {
        partnerName = "DHL Kargo"
    }

    const handleRedirectToRefund = () => {
        navigate(`/dashboard/cargo-partner-operations/ecommerce-refund/${partner}`);
    };
    const handleRedirectToTakeOrder = () => {
        navigate(`/dashboard/cargo-partner-operations/take-order/${partner}`);
    };
    const handleRedirectToGivingBack = () => {
        navigate(`/dashboard/cargo-partner-operations/giving-back/${partner}`);
    };
    const handleRedirectToTakeEcommerce = () => {
        navigate(`/dashboard/cargo-partner-operations/take-ecommerce/${partner}`);
    };
    const handleRedirectToTakeDropOff = () => {
        navigate(`/dashboard/cargo-partner-operations/take-dropoff/${partner}`);
    };
    const handleRedirectToTakeRequest = () => {
        navigate(`/dashboard/cargo-partner-operations/request/${partner}`);
    };
    const handleRedirectToOrderCreation = () => {
        navigate(`/dashboard/cargo-partner-operations/order-creation/${partner}`);
    };

    return (
        <>
            <Helmet>
                <title> {language.cargo_partner_receive.titles.site_title} </title>
            </Helmet>

            <Stack style={{ paddingInline: '25px' }}>
                <Stack
                    direction="column"
                    alignItems="flex-start"
                    mb={5}
                >
                    <Typography variant="h4" gutterBottom>
                        {language.cargo_partner_receive.titles.title}
                    </Typography>
                    <p style={{ color: '#D1D1D1', fontSize: '16px', fontWeight: '400' }}>
                        {partnerName === "DHL Kargo"
                            ? partnerName
                            : `${partnerName} - ${language.commons.labels.embezzle}`}
                    </p>
                    <HorizontalDivider />
                </Stack>

                {partner === "aras-kargo" ? (
                    <>
                        <OptionsButton onClick={handleRedirectToGivingBack} title={language.commons.labels.refund} />
                        <OptionsButton onClick={handleRedirectToRefund} title={language.commons.labels.e_commerce} />
                        <OptionsButton onClick={handleRedirectToTakeOrder} title={language.commons.labels.receive_shipment} />
                        {(parsedUser.type === "highadmin" || parsedUser.type === "superadmin") && (
                            <OptionsButton onClick={handleRedirectToTakeEcommerce} title={language.commons.labels.receive_ecommerce} />
                        )}
                    </>
                ) : ( /* DHL Gönderi Oluşturma */
                    <>
                        <OptionsButton onClick={handleRedirectToOrderCreation} title={language.commons.labels.dhl_create_past} />
                        <OptionsButton onClick={handleRedirectToTakeRequest} title={language.commons.labels.dhl_create_support_request} />
                        <OptionsButton onClick={handleRedirectToTakeEcommerce} title={language.commons.labels.receive_ecommerce} />
                        <OptionsButton onClick={handleRedirectToTakeDropOff} title={language.commons.labels.dhl_create_dropoff_request} />
                    </>
                )}
            </Stack>
        </>
    )
}
